<div class="chargepoint-page">
  <app-chargepoint-card [chargepoint]="chargepoint" [hideActions]="true" class="chargepoint-identity sticky"></app-chargepoint-card>
  <mat-card class="chargepoint-quick-actions sticky">
    <mat-card-header>
      <mat-card-title>Quick Actions</mat-card-title>
    </mat-card-header>
    <mat-card-content class="chargepoint-quick-actions-content">
      <button mat-icon-button matTooltip="Inspect json" (click)="jsonViewerService.openJsonViewer(chargepoint)">
        <mat-icon>data_object</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        matTooltip="View logs"
        (click)="showLogsDialog()">
        <mat-icon>article</mat-icon>
      </button>
      <div class="spacer"></div>
      <button mat-icon-button matTooltip="Request diagnostic" (click)="requestDiagnostic()">
        <mat-icon>bug_report</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Clear cache" (click)="requestClearCache()">
        <mat-icon>delete_sweep</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Make operative" (click)="changeAvailabilityToOperative()">
        <mat-icon>sunny</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Reboot" [matMenuTriggerFor]="powerActionsMenu">
        <mat-icon>power_settings_new</mat-icon>
      </button>
      <mat-menu #powerActionsMenu="matMenu">
        <button mat-menu-item (click)="requestReboot(false)">
          <mat-icon>refresh</mat-icon>
          <span>Soft reboot</span>
        </button>
        <button mat-menu-item (click)="requestReboot(true)">
          <mat-icon>power_settings_new</mat-icon>
          <span>Hard reboot</span>
        </button>
      </mat-menu>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-sessions">
    <mat-card-header>
      <mat-card-title>Sessions history</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-sessions-history [chargepoint]="chargepoint"></app-sessions-history>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-transactions">
    <mat-card-header>
      <mat-card-title>Transactions</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-transactions-list [chargepoint]="chargepoint"></app-transactions-list>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-statuses">
    <mat-card-header>
      <mat-card-title>Connectors</mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="chargepoint">
      <ng-container *ngFor="let item of (chargepoint.connectors | keyvalue); let first = first">
        <div class="connector-row">
          <span>
            Connector {{item.value.connectorId}}
          </span>
          <app-chargepoint-status [status]="item.value.status"></app-chargepoint-status>
          <div class="connector-row-actions">
            <button mat-icon-button color="primary" matTooltip="Start transaction" [disabled]="!['AVAILABLE', 'PREPARING'].includes(item.value.status)" (click)="startTransaction(item.value.connectorId)">
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button mat-icon-button color="primary" matTooltip="Unlock connector" (click)="unlockConnector(item.value.connectorId)">
              <mat-icon>electrical_services</mat-icon>
            </button>
            <button mat-icon-button color="primary" matTooltip="Request status" (click)="requestConnectorStatus(item.value.connectorId)">
              <mat-icon>sync</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-local-authorization-list" [class.header-only]="!isLocalAuthorizationListSupported">
    <mat-card-header class="fullwidth">
      <mat-card-title class="fullwidth space-between">
        <span>Local Authorization List</span>
        <span
          *ngIf="localAuthorizationListStatus as status"
          class="local-authorization-list-status"
          [ngClass]="localAuthorizationListStatusClass">
          <mat-icon>{{ localAuthListStatusConfig[status].icon }}</mat-icon>
          <span>{{ localAuthListStatusConfig[status].label }}</span>
        </span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="isLocalAuthorizationListSupported">
      <app-chargepoint-local-authorization-list-ocpp
        [chargepoint]="chargepoint"
        (refresh)="refresh.emit()">
      </app-chargepoint-local-authorization-list-ocpp>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-configuration">
    <mat-card-header class="fullwidth">
      <mat-card-title class="fullwidth space-between">
        <span>Configurations</span>
        <button mat-icon-button matTooltip="Refresh configurations" (click)="refreshConfigurationTrigger$.next()">
          <mat-icon>refresh</mat-icon>
        </button>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-chargepoint-configuration-ocpp [chargepoint]="chargepoint" [refreshTrigger]="refreshConfigurationTrigger$"></app-chargepoint-configuration-ocpp>
    </mat-card-content>
  </mat-card>
  <mat-card class="chargepoint-diagnostics">
    <mat-card-header>
      <mat-card-title>Diagnostics</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-chargepoint-diagnostics [chargepoint]="chargepoint"></app-chargepoint-diagnostics>
    </mat-card-content>
  </mat-card>
</div>
